import BaseFoundation from '../base/foundation';
export default class YearAndMonthFoundation extends BaseFoundation {
  constructor(adapter) {
    super(Object.assign({}, adapter));
  } // eslint-disable-next-line @typescript-eslint/no-empty-function


  init() {} // eslint-disable-next-line @typescript-eslint/no-empty-function


  destroy() {}

  selectYear(item) {
    const year = item.value;

    this._adapter.setCurrentYear(year);

    this._adapter.notifySelectYear(year);
  }

  selectMonth(item) {
    const {
      month
    } = item;

    this._adapter.setCurrentMonth(month);

    this._adapter.notifySelectMonth(month);
  }

  backToMain() {
    this._adapter.notifyBackToMain();
  }

}